"use client";

import { useEffect } from "react";
import { trackEvent, TRACKING_EVENTS } from "@/lib/tracking";

/**
 * Zählt Klicks auf eine Telefonnummer als Anfrage.
 *
 * WARUM ein einziger Zuhörer am Dokument statt elf onClick-Handler:
 * `site.contact.phoneHref` steht an elf Stellen – Hero, Footer, Kontakt,
 * Impressum, jede Betreuungsseite. Jede davon mit einem Handler zu
 * versehen hieße, elf Server-Komponenten zu Client-Komponenten zu machen.
 * Ein Zuhörer in der Erfassungsphase am Dokument fängt alle ab, auch die,
 * die erst später dazukommen.
 *
 * Für Handwerks- und Dienstleistungsbetriebe ist der Anruf oft der
 * wichtigere Weg als das Formular. Wurde er nicht gezählt, optimierte
 * Google Ads auf die Hälfte der Wahrheit.
 *
 * Datenschutz: Übergeben wird nur, ob geklickt wurde und auf welcher
 * Seite – nie die Nummer des Anrufers, die kennen wir ohnehin nicht.
 * Vor der Einwilligung landet der Eintrag nur im dataLayer-Array; GTM
 * wird erst nach Zustimmung geladen (siehe Analytics.tsx).
 */
export function AnrufTracking() {
  useEffect(() => {
    function beiKlick(e: MouseEvent) {
      const ziel = e.target as Element | null;
      const link = ziel?.closest?.('a[href^="tel:"]');
      if (!link) return;
      trackEvent(TRACKING_EVENTS.anruf, {
        // Wo wurde geklickt – damit sichtbar wird, welche Seite Anrufe bringt.
        seite: window.location.pathname,
      });
    }
    // Erfassungsphase: greift auch, wenn ein Handler darunter stopPropagation ruft.
    document.addEventListener("click", beiKlick, true);
    return () => document.removeEventListener("click", beiKlick, true);
  }, []);

  return null;
}
